<template>
  <!-- eslint-disable vue/attribute-hyphenation -->
  <div
    :class="$style.inputContainer"
    @click="handleClick"
  >
    <InputLabel
      v-if="label"
      :name="name"
      :text="cleanLabel(label)"
    />
    <IconTooltip v-if="tooltip">
      <!-- DO NOT ALLOW ANY USER INPUT IN STRING PASSED TO v-html -->
      <!-- eslint-disable vue/no-v-html -->
      <p
        v-if="tooltip.text"
        v-html="tooltip.text"
      />
      <!-- eslint-disable vue/no-v-html -->
      <div
        v-if="tooltip.kbLink"
        :class="$style.kbLinkContainer"
      >
        <a
          class="kbLink"
          :href="tooltip.kbLink"
          rel="noopener noreferrer"
          target="_blank"
        >
          {{ tooltip.kbLinkText }}
        </a>
        <a
          class="kbLink"
          :href="tooltip.kbLink"
          rel="noopener noreferrer"
          target="_blank"
        >
          <i class="jc-tool-kb" />
        </a>
      </div>
    </IconTooltip>
    <slot
      :inputClass="inputClass"
    />
    <div
      :class="[$style.error, errorStyleExceptions]"
      data-test-id="OptionalValidationWrapper__errorContainer"
    >
      <transition
        :enter-active-class="$style.fadeEnterActive"
        :enter-class="$style.fadeEnter"
        :leave-active-class="$style.fadeLeaveActive"
        :leave-to-class="$style.fadeLeaveTo"
        name="fade"
      >
        <span
          v-if="$validator.errors.any()"
          data-test-id="OptionalValidationWrapper__error"
        >{{ cleanHandleError() }}</span>
      </transition>
    </div>
  </div>
</template>
<script>
import { InputLabel } from '@jumpcloud/ui-components';
import IconTooltip from 'components/Tooltip/IconTooltip.vue';
import TooltipPropMixin from 'components/FormValidation/mixins/TooltipPropMixin';

export default {
  name: 'OptionalValidationWrapper',

  components: {
    IconTooltip,
    InputLabel,
  },

  inject: ['$validator'],

  mixins: [
    TooltipPropMixin,
  ],

  props: {
    clickPrevent: {
      type: Boolean,
      default: true,
    },
    errorStyleExceptions: {
      type: [String, Array],
      default: null,
    },
    handleError: {
      type: Function,
      default: () => {},
    },
    inputClass: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
  },

  methods: {

    cleanHandleError() {
      if (this.handleError()) {
        if (this.handleError().includes('--')) {
          const errorMessage = this.handleError().split('--');
          return errorMessage[0] + errorMessage[1].substring(1);
        }
      }
      return this.handleError();
    },

    cleanLabel(label) {
      if (label.includes('--')) {
        return label.split('--')[0];
      }
      return label;
    },

    handleClick(e) {
      if (this.clickPrevent) {
        e.preventDefault();
      }
    },
  },
};
</script>
<style module>
@import "./css/formFields.css";
@import "./css/FormValidationFields.css";

.kbLinkContainer {
  display: flex;
  float: right;
  padding-top: 5px;
}
</style>
